function setGalleryCollapsed(value) {
    document.body.classList.toggle('tee-gallery--collapsed', value);
}

function isGalleryCollapsed() {
    return document.body.classList.contains('tee-gallery--collapsed');
}

function addScrollAnimation() {
    const image = document.querySelector('.tee-gallery-content');
    const wrapper = document.querySelector('.tee-gallery-wrapper');
    if (!image || !wrapper) return;

    let ticking = false;
    let cachedHeight = image.offsetHeight || 500;

    const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
            const newHeight = image.offsetHeight;

            if (newHeight > 100 && Math.abs(cachedHeight - newHeight) > 5) {
                cachedHeight = newHeight;
                window.dispatchEvent(new Event('scroll'));
            }
        }
    });
    resizeObserver.observe(image);

    window.addEventListener('scroll', () => {
        if (window.innerWidth < 768) {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollY = Math.max(0, window.scrollY);

                    const startScroll = 20;
                    const endScroll = 200;
                    const minScale = 0.7;

                    let scaleValue = 1;

                    if (scrollY <= startScroll) {
                        document.body.classList.remove('tee-gallery--is-sticky', 'tee-gallery--animating', 'tee-gallery-sticky');
                        setGalleryCollapsed(false);
                        scaleValue = 1;

                        wrapper.style.height = '';
                    } else if (scrollY > startScroll && scrollY < endScroll) {
                        document.body.classList.add('tee-gallery--is-sticky', 'tee-gallery--animating');
                        document.body.classList.remove('tee-gallery-sticky');

                        const t = (scrollY - startScroll) / (endScroll - startScroll);
                        scaleValue = 1 - t * (1 - minScale);
                    } else {
                        document.body.classList.add('tee-gallery--is-sticky', 'tee-gallery-sticky');
                        document.body.classList.remove('tee-gallery--animating');
                        scaleValue = minScale;
                    }

                    scaleValue = Number(scaleValue.toFixed(3));

                    image.style.transform = `scale(${scaleValue})`;
                    image.style.marginBottom = '0px';

                    if (scrollY > startScroll) {
                        const currentHeight = Math.round(cachedHeight * scaleValue) + 10; // +10px padding đệm
                        wrapper.style.height = `${currentHeight}px`;
                    }

                    ticking = false;
                });
                ticking = true;
            }
        } else {
            image.style.transform = 'none';
            wrapper.style.height = '';
            document.body.classList.remove('tee-gallery--is-sticky', 'tee-gallery--animating', 'tee-gallery-sticky');
            setGalleryCollapsed(false);
        }
    }, { passive: true });

    window.dispatchEvent(new Event('scroll'));
}

function initGalleryHandle() {
    const mediaWrapper = document.querySelector('.t4s-product__media-wrapper');
    if (!mediaWrapper || mediaWrapper.querySelector('.tee-gallery__handle')) return;

    const clip = document.createElement('div');
    clip.className = 'tee-gallery__clip';
    while (mediaWrapper.firstChild) {
        clip.appendChild(mediaWrapper.firstChild);
    }
    mediaWrapper.appendChild(clip);

    const handle = document.createElement('div');
    handle.className = 'tee-gallery__handle';
    handle.setAttribute('role', 'button');
    handle.setAttribute('aria-label', 'Vorschaubild ein-/ausblenden');
    handle.setAttribute('aria-expanded', 'true');
    handle.innerHTML = '<svg viewBox="0 14.66 194.3 34.35" aria-hidden="true">'
        + '<path fill="#fff" d="M0,14.66c8.48,0,16.38,4.3,20.99,11.41h0c9.26,14.3,25.14,22.94,42.17,22.94h67.99c17.04,0,32.91-8.63,42.17-22.94h0c4.61-7.12,12.51-11.41,20.99-11.41"/>'
        + '<path class="tee-gallery__chevron" fill="none" stroke="#bfbfbf" stroke-linecap="round" stroke-linejoin="round" stroke-width="10.02" d="M73.06,18.56l21.29-12.33c2.8-1.62,6.09-1.62,8.89,0l21.29,12.33"/>'
        + '</svg>';
    mediaWrapper.appendChild(handle);

    let pointerStartY = null;

    handle.addEventListener('pointerdown', (e) => {
        pointerStartY = e.clientY;
    });

    handle.addEventListener('pointerup', (e) => {
        if (pointerStartY === null) return;
        const deltaY = e.clientY - pointerStartY;
        pointerStartY = null;

        let collapsed;
        if (deltaY < -20) {
            collapsed = true;
        } else if (deltaY > 20) {
            collapsed = false;
        } else {
            collapsed = !isGalleryCollapsed();
        }
        setGalleryCollapsed(collapsed);
        handle.setAttribute('aria-expanded', String(!collapsed));
    });

    handle.addEventListener('pointercancel', () => {
        pointerStartY = null;
    });
}

function fixedLivePreview() {
    const style = document.createElement("style");
    style.innerHTML = `
        @media only screen and (max-width: 768px) {
            body.teeinblue-enabled {
                overflow-anchor: none !important;
            }

            body:not(.sticky-is--active) header#shopify-section-header-inline {
                position: static !important;
                transform: none !important;
                transition: none !important;
                animation: none !important;
            }

            .teeinblue-enabled .t4s-product__media-wrapper {
                width: 100%;
                max-width: 100vw;
                position: relative;
                margin-left: 0;
                background: #ffffff;
                padding-bottom: 10px;
                transition: background .3s ease-in-out, box-shadow .3s ease-in-out, filter .3s ease-in-out;
            }

            .teeinblue-enabled.tee-gallery--is-sticky .t4s-product__media-wrapper {
                position: sticky;
                top: 0 !important;
                z-index: 999;
            }

            .teeinblue-enabled.tee-gallery-sticky .t4s-product__media-wrapper {
                background: #ffffff;
                filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
            }

            .teeinblue-enabled .t4s-product__media-wrapper #tee-gallery {
                height: auto !important;
                margin: 0 auto;
                max-width: 100%;
                transition: none !important;
                transform-origin: top center;
                will-change: transform, margin-bottom;
                transform: translateZ(0);
            }

            .teeinblue-item.teeinblue-item--product {
                z-index: 999999;
            }

            .teeinblue-enabled.tee-gallery-sticky .tee-thumbnails {
               display: none !important;
            }

            .teeinblue-enabled.tee-gallery--is-sticky .tee-gallery__clip {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                overflow: hidden;
                transition: max-height .35s ease;
                max-height: 2000px;
            }

            .teeinblue-enabled.tee-gallery--collapsed .tee-gallery__clip {
                max-height: 30px;
            }

            .tee-gallery__handle {
                display: none;
                position: absolute;
                left: 50%;
                bottom: -6px;
                width: 70px;
                height: 12.4px;
                transform: translateX(-50%);
                z-index: 1;
                cursor: grab;
                touch-action: none;
                user-select: none;
            }

            .teeinblue-enabled.tee-gallery--is-sticky .tee-gallery__handle {
                display: block;
            }

            .tee-gallery__handle svg {
                width: 100%;
                height: 100%;
                display: block;
                overflow: visible;
            }

            .tee-gallery__chevron {
                transition: transform .3s ease;
                transform: rotate(0deg);
                transform-box: fill-box;
                transform-origin: 50% 50%;
            }

            body.tee-gallery--collapsed .tee-gallery__chevron {
                transform: rotate(180deg);
            }
        }
    `;
    document.head.appendChild(style);

    initGalleryHandle();
    addScrollAnimation();
}

document.addEventListener("DOMContentLoaded", () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    if (h / w > 1.5 && w < 768) {
        const observer = new MutationObserver((mutations, obs) => {
            const image = document.querySelector('.tee-gallery-content');
            const wrapper = document.querySelector('.tee-gallery-wrapper');

            if (image && wrapper) {
                fixedLivePreview();
                obs.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
});
